import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { TaxProvider } from '@helpers/hooks/pages/dashboard/tax/useTax';

import Wrapper from '@components/Dashboard/Tax/Wrapper';
import NoAccess from '@components/common/core/Utils/NoAccess';

const Tax: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_tax_full_write_access ||
    accessManagementData?.group?.has_tax_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <TaxProvider>
      <Wrapper />
    </TaxProvider>
  );
};

export default Tax;
